import React, { FC, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import PhoneNumberInput from "@/components/PhoneNumberInput";
import { AddOUFormData } from "./validation.schema";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";
import { useCountrySetting } from "@/hooks/useSetting";

type TabOrganizationContactProps = {
  editMode?: boolean;
};

export const TabOrganizationContact: FC<TabOrganizationContactProps> = ({
  editMode = false,
}) => {
  const { t } = useTranslation("organization");

  const countrySetting = useCountrySetting();
  const country = useMemo(() => countrySetting, [countrySetting]);

  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<AddOUFormData>();

  return (
    <Grid container spacing={"20px"}>
      <Grid size={6}>
        <Controller
          name="contactName"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="contactName"
              label={t("modals.label-contact-name")}
              variant="outlined"
              required
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.contactName}
              helperText={
                errors.contactName ? errors.contactName.message : null
              }
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid size={6}>
        <Controller
          name="contactPhone"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <PhoneNumberInput
              {...field}
              defaultCode={country}
              value={field.value}
              label={t("modals.label-phone-number")}
              variant="outlined"
              className="flex flex-1 w-full"
              required
              onChange={(value) => field.onChange(value)}
              error={!!errors.contactPhone}
              helperText={
                errors.contactPhone ? errors.contactPhone.message : null
              }
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
